// Types
import type { TDropdownOpenState, TDropdownPosition, TDropdownProps, TDropdownStyle } from './Dropdown.type';

/*
 This Gap is used to separate the Dropdown from the trigger.
 There's no token for the Dropdown Gap. It's following the Figma design and valid per 22 Nov 2024.
*/
export const DROPDOWN_GAP = 12

/*
 This is the default timeout for the Dropdown transition to be opened / closed.
 The timeout value is in milliseconds.
 */
export const DROPDOWN_TIMEOUT = 400;
export const DROPDOWN_PADDING_OPEN = 'var(--dropdown-padding-container-top-bottom) var(--dropdown-padding-container-left-right)'
export const DROPDOWN_PADDING_CLOSE = '0 var(--dropdown-padding-container-left-right)'

export const DROPDOWN_DEFAULT_OPEN_STATE: TDropdownOpenState = {
	isOpen: true,
	isShow: true,
}

export const DROPDOWN_DEFAULT_STYLE: TDropdownStyle = {
	height: 'auto',
	left: 0,
	top: 0,
}

export const DROPDOWN_POSITIONS: TDropdownPosition[] = [
	'bottom-center',
	'bottom-left',
	'bottom-right',
	'left-bottom',
	'left-center',
	'left-top',
	'right-bottom',
	'right-center',
	'right-top',
	'top-center',
	'top-left',
	'top-right',
];
export const DROPDOWN_POSITION: { [key in TDropdownPosition]: key } = {
	['bottom-center']: 'bottom-center',
	['bottom-left']: 'bottom-left',
	['bottom-right']: 'bottom-right',
	['left-bottom']: 'left-bottom',
	['left-center']: 'left-center',
	['left-top']: 'left-top',
	['right-bottom']: 'right-bottom',
	['right-center']: 'right-center',
	['right-top']: 'right-top',
	['top-center']: 'top-center',
	['top-left']: 'top-left',
	['top-right']: 'top-right',
};

export const DROPDOWN_DEFAULT_PROPS: Omit<TDropdownProps, 'children' | 'trigger'> = {
	position: DROPDOWN_POSITION['bottom-left']
};
